import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { profile } from '../../common/content';
import experience from '../../common/experience.json';
import { analytics } from '../../utils/analytics';

export const SummaryScreen = () => (
  <>
    <header className="container summary__title">
      <div><p className="eyebrow">Trayectoria profesional</p><h1>Experiencia y formación.</h1></div>
      <a href={profile.cv} download="CV2026-RaySaracual.pdf" className="button primary" onClick={() => analytics.trackCVDownload('experience')}><FontAwesomeIcon icon={faDownload} /> Descargar CV</a>
    </header>
    <div className="container"><p className="summary-context">Experiencia en modernización de sistemas, desarrollo de producto e integración.</p></div>
    <div className="container summary__section">
      <section aria-labelledby="experience-title">
        <h2 id="experience-title">Experiencia</h2>
        {experience.roles.map(role => (
          <article className="summary__item" key={`${role.company}-${role.title}`}>
            <h3>{role.title}<br /><span>{role.company}</span></h3>
            <p>{role.period}</p><p>{role.location}</p><p>{role.description}</p>
            <h4>Tecnologías y herramientas</h4><p>{role.technologies}</p>
          </article>
        ))}
      </section>
      <aside aria-label="Formación y competencias">
        <h2>Formación</h2>
        <div className="summary__item"><h3>{experience.education.title}</h3><p>{experience.education.institution}</p><p>{experience.education.period}</p></div>
        <h2>Cursos</h2><div className="summary__item"><ul>{experience.courses.map(course => <li key={course}>{course}</li>)}</ul></div>
        <h2>Competencias técnicas</h2>
        {experience.skills.map(skill => <div className="summary__item" key={skill.title}><h3>{skill.title}</h3><p>{skill.items}</p></div>)}
        <h2>Comunidad</h2><div className="summary__item"><p>{experience.community}</p></div>
      </aside>
    </div>
  </>
);